import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Subject, takeUntil } from 'rxjs';
import { REQUEST_OTP_EMAIL } from 'src/app/constants/endpoint.const';
import { BaseService } from 'src/app/services/base.service';

@Component({
  selector: 'app-modal-verif-email-team',
  standalone: false,
  templateUrl: './modal-verif-email-team.component.html',
  styleUrl: './modal-verif-email-team.component.scss'
})
export class ModalVerifEmailTeamComponent {
  $destroy = new Subject
  @Input() isOpen: boolean = false;
  @Output() close = new EventEmitter<void>();
  isOtpVerifOpen: boolean = false;
  emailTeam: string = localStorage.getItem('email-user') || '';
  token: string = ''

  constructor(
    private baseService: BaseService,
    private message: NzMessageService
  ) { }

  sendOTP() {
    const params = {
      purpose: 'team',
      email: this.emailTeam,
    }
    this.baseService.postData(REQUEST_OTP_EMAIL, params)
      .pipe(takeUntil(this.$destroy))
      .subscribe((res) => {
        this.token = res.data.token
        this.message.success('Send OTP Success, please check your email')
        this.isOtpVerifOpen = true
        this.isOpen = false;
        this.close.emit();
      },
        (err) => {
        this.message.error(err.error.meta.message)
      })
  }
}
